/* eslint-disable max-len */
/* eslint-disable no-template-curly-in-string */
import React, { useEffect } from "react";
import uniqueId from "lodash/uniqueId";
import { FieldArray } from "formik";
import Grid from "@mui/material/Grid";
import {
  Input,
  Checkbox,
  SelectAutocomplete,
  AutoSaveField as Field,
  CheckboxGroup
} from "../../../../components/Form";
import { ArrayRemoveButton } from "../Buttons/ArrayRemoveButton";
import { ArrayAddButton } from "../Buttons/ArrayAddButton";
import {
  limits,
  INITIAL_ARRAY_INDEX,
  initialoutSideUAE,
  initialBankLoan,
  BASED_IN_NONUAE,
  BASED_IN_UAE
} from "./constants";
import { baseLocation } from "../../../../constants/options";
import { GroupLabel, Divider, RelativeBox, TabletBox, AddButton, RemoveButton } from "./styled";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { Label } from "../styled";

export const CompanyBankingRelationshipsComponent = ({
  updateProspect,
  outsideUAE,
  bankLoan,
  withinUAE,
  isComeFromROScreens,
  values,
  setFieldValue,
  setTouched
}) => {
  const otherBankProspectPath = "prospect.orgKYCDetails.otherBankingRelationshipsInfo";

  useEffect(() => {
    let uaedata = [];
    let nonUaedata = [];
    let finalArray = [];
    const obj = {
      basedIn: "",
      bankName: "",
      iban: "",
      currency: "",
      loanFacility: ""
    };
    if ((withinUAE && withinUAE?.length > 0) || (outsideUAE && outsideUAE?.length > 0)) {
      let result = withinUAE.filter(item => item.loanExists === true);
      if (result && result.length > 0) {
        let finalResult = result.map(data => {
          obj.basedIn = BASED_IN_UAE;
          obj.bankName = data.bankName;
          obj.iban = data.iban;
          obj.currency = data.currency;
          obj.loanFacility = data.loanType;
          let temp = { ...obj };
          return temp;
        });
        uaedata = finalResult;
      }
      let resultnonUae = outsideUAE.filter(item => item.loanExists === true);
      if (resultnonUae && resultnonUae?.length > 0) {
        let finalResultNonUae = resultnonUae.map(data => {
          obj.basedIn = BASED_IN_NONUAE;
          obj.bankName = data.bankName;
          obj.iban = data.iban;
          obj.currency = data.currency;
          obj.loanFacility = data.loanType;
          let temp = { ...obj };
          return temp;
        });
        nonUaedata = finalResultNonUae;
      }
      finalArray = [...uaedata, ...nonUaedata];
      setFieldValue("bankLoanWithCompanyAccount", true);
      setFieldValue("otherBankLoanRelationship", finalArray);
      updateProspect({
        "prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship": finalArray
      });
    }
  }, [values.outsideUAE, outsideUAE, setFieldValue, updateProspect, withinUAE]);

  const createChangeProspectHandler = (values, index) => prospect => ({
    ...prospect,
    [`prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship[${index}].bankName`]: "",
    [`prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship[${index}].iban`]: "",
    [`prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship[${index}].currency`]: "",
    [`prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship[${index}].loanFacility`]: ""
  });
  const isOutsideUAE = values.outsideUAE?.length > 1;
  const isBankLoan = values.otherBankLoanRelationship?.length > 1;

  return (
    <React.Fragment>
      {isComeFromROScreens && (
        <React.Fragment>
          <FieldArray name="outsideUAE">
            {arrayHelpers => (
              <>
                <Grid container sx={{ mt: 0, rowGap: "16px" }}>
                  <Grid item xs={12}>
                    <GroupLabel>Outside the UAE</GroupLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      path="prospect.orgKYCDetails.otherBankingRelationshipsInfo.outsideUAEBankAccountExist"
                      name="companyAccountWithBankOutsideUAE"
                      label="The company has an account with another bank outside UAE"
                      component={Checkbox}
                      onSelect={() => {
                        if (!values.companyAccountWithBankOutsideUAE) {
                          setFieldValue(
                            "outsideUAE",
                            initialoutSideUAE.map(item => ({
                              ...item,
                              id: uniqueId()
                            }))
                          );
                          setTouched({
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].bankName`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].iban`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].currency`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].loanExists`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].loanType`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].loanAmount`]: false,
                            [`outsideUAE[${INITIAL_ARRAY_INDEX}].loanCurrency`]: false
                          });
                        }
                      }}
                      inputProps={{ tabIndex: 0 }}
                    />
                  </Grid>
                </Grid>
                {values.companyAccountWithBankOutsideUAE && (
                  <>
                    <Grid container spacing={3} sx={{ mt: 0 }}>
                      {values.outsideUAE.map((item, index) => (
                        <React.Fragment key={item.id}>
                          <Grid item sm={isOutsideUAE ? 5 : 6} xs={12}>
                            <Field
                              name={`outsideUAE[${index}].bankName`}
                              path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].bankName`}
                              label="Bank name"
                              placeholder="Bank name"
                              component={Input}
                            />
                          </Grid>
                          <Grid
                            item
                            sm={isOutsideUAE ? 5 : 6}
                            xs={12}
                            component={!index ? TabletBox : RelativeBox}
                            sx={{ mt: { xs: 2, sm: 0 }, mb: "0 !important" }}
                          >
                            <Field
                              name={`outsideUAE[${index}].iban`}
                              path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].iban`}
                              label="IBAN"
                              component={Input}
                              InputProps={{
                                inputProps: { tabIndex: 0, maxLength: 23 }
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            sm={isOutsideUAE ? 10 : 12}
                            xs={12}
                            sx={{ mt: { xs: 2, sm: 3 } }}
                          >
                            <Field
                              name={`outsideUAE[${index}].currency`}
                              path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].currency`}
                              label="Currency"
                              component={SelectAutocomplete}
                              shrink
                              tabIndex="0"
                              datalistId="accountCurrencies"
                            />
                          </Grid>
                          <Grid item sm={12} xs={12} sx={{ mt: { xs: 2, sm: 3 } }}>
                            <Field
                              name={`outsideUAE[${index}].loanExists`}
                              label="The company has a loan/finance with this Bank"
                              path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].loanExists`}
                              component={Checkbox}
                              inputProps={{ tabIndex: 0 }}
                            />
                          </Grid>
                          <Grid
                            item
                            sm={isOutsideUAE ? 10 : 12}
                            xs={12}
                            sx={{ mt: { xs: 2, sm: 3 } }}
                          >
                            <Field
                              name={`outsideUAE[${index}].loanType`}
                              label="Finance/Facility type"
                              path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].loanType`}
                              component={SelectAutocomplete}
                              tabIndex="0"
                              datalistId="loanOrFacilityType"
                              disabled={!values.outsideUAE[index].loanExists}
                            />
                          </Grid>
                          <Grid container item spacing={3} sx={{ mt: { xs: 2, sm: 3 } }}>
                            <Grid item sm={isOutsideUAE ? 5 : 6} xs={12}>
                              <Field
                                name={`outsideUAE[${index}].loanAmount`}
                                path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].loanAmount`}
                                label="Finance/Facility amount"
                                component={Input}
                                InputProps={{
                                  inputProps: { tabIndex: 0 }
                                }}
                                disabled={!values.outsideUAE[index].loanExists}
                              />
                            </Grid>
                            <Grid
                              item
                              sm={isOutsideUAE ? 5 : 6}
                              xs={12}
                              sx={{ mt: { xs: 2, sm: 0 } }}
                            >
                              <Field
                                name={`outsideUAE[${index}].loanCurrency`}
                                label="Currency"
                                path={`prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE[${index}].loanCurrency`}
                                component={SelectAutocomplete}
                                disabled={!values.outsideUAE[index].loanExists}
                                shrink
                                tabIndex="0"
                                datalistId="accountCurrencies"
                              />

                              {isOutsideUAE && (
                                <ArrayRemoveButton
                                  arrayHelpers={arrayHelpers}
                                  dataArray={outsideUAE}
                                  itemIndex={index}
                                  updateProspect={updateProspect}
                                  prospectPath="prospect.orgKYCDetails.otherBankingRelationshipsInfo.bankDetailsOutsideUAE"
                                  title="Delete"
                                  component={RemoveButton}
                                />
                              )}
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>

                    {values.outsideUAE?.length < limits.ANOTHER_BANK_COUNT && (
                      <Box sx={{ display: "flex" }}>
                        <ArrayAddButton
                          title="Add another bank"
                          limit={limits.ANOTHER_BANK_COUNT}
                          requiredFields={["bankName", "iban"]}
                          addedItem={{ bankName: "", iban: "" }}
                          dataArray={values.outsideUAE}
                          arrayHelpers={arrayHelpers}
                          component={AddButton}
                        />
                      </Box>
                    )}
                  </>
                )}
              </>
            )}
          </FieldArray>
          <Divider />
        </React.Fragment>
      )}
      {values.otherBankLoanRelationship?.length > 0 ? (
        <>
          <Field
            path="prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanExist"
            name="bankLoanWithCompanyAccount"
            label="Borrowing/Finance with any other Banks?"
            component={Checkbox}
            disabled={true}
            inputProps={{ tabIndex: 0 }}
            onSelect={() => {
              if (!values.bankLoanWithCompanyAccount) {
                setFieldValue(
                  "otherBankLoanRelationship",
                  initialBankLoan.map(item => ({
                    ...item,
                    id: uniqueId()
                  }))
                );
                setTouched({
                  [`otherBankLoanRelationship[${INITIAL_ARRAY_INDEX}].basedIn`]: false,
                  [`otherBankLoanRelationship[${INITIAL_ARRAY_INDEX}].bankName`]: false,
                  [`otherBankLoanRelationship[${INITIAL_ARRAY_INDEX}].iban`]: false,
                  [`otherBankLoanRelationship[${INITIAL_ARRAY_INDEX}].currency`]: false,
                  [`otherBankLoanRelationship[${INITIAL_ARRAY_INDEX}].loanFacility`]: false
                });
              } else {
                setFieldValue("otherBankLoanRelationship", initialBankLoan);
                updateProspect({
                  "prospect.orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship": initialBankLoan
                });
              }
            }}
          />
          <FieldArray name="otherBankLoanRelationship">
            {arrayHelpers => (
              <>
                {values.bankLoanWithCompanyAccount && (
                  <>
                    {values.otherBankLoanRelationship.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <Grid container spacing={3} sx={{ mt: 0, rowGap: "16px" }}>
                          <Grid item xs={12}>
                            <Label>Where are they based?</Label>
                          </Grid>
                          <Grid item xs={12}>
                            <Field
                              name={`otherBankLoanRelationship[${index}].basedIn`}
                              path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].basedIn`}
                              component={CheckboxGroup}
                              disabled={true}
                              options={baseLocation}
                              onSelect={() => {
                                setFieldValue(`otherBankLoanRelationship[${index}].bankName`, "");
                                setFieldValue(`otherBankLoanRelationship[${index}].iban`, "");
                                setFieldValue(`otherBankLoanRelationship[${index}].currency`, "");
                                setFieldValue(
                                  `otherBankLoanRelationship[${index}].loanFacility`,
                                  ""
                                );

                                setTouched({
                                  [`otherBankLoanRelationship[${index}].bankName`]: true,
                                  [`otherBankLoanRelationship[${index}].iban`]: true,
                                  [`otherBankLoanRelationship[${index}].currency`]: true,
                                  [`otherBankLoanRelationship[${index}].loanFacility`]: true
                                });
                              }}
                              changeProspect={createChangeProspectHandler(values, index)}
                              sx={{ root: { radioButtonRoot: true } }}
                              typeRadio
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3} sx={{ mt: 0 }}>
                          <Grid item sm={isBankLoan ? 5 : 6} xs={12}>
                            {values.otherBankLoanRelationship[index].basedIn === "UAE" ? (
                              <Field
                                name={`otherBankLoanRelationship[${index}].bankName`}
                                path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].bankName`}
                                label="Bank name"
                                placeholder="Bank name"
                                disabled={true}
                                component={SelectAutocomplete}
                                datalistId="uaeBankName"
                              />
                            ) : (
                              <Field
                                name={`otherBankLoanRelationship[${index}].bankName`}
                                path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].bankName`}
                                label="Bank name"
                                placeholder="Bank name"
                                component={Input}
                                disabled={true}
                                InputProps={{
                                  inputProps: { tabIndex: 0, maxLength: 50 }
                                }}
                              />
                            )}
                          </Grid>
                          <Grid item sm={isBankLoan ? 5 : 6} xs={12} sx={{ mt: { xs: 2, sm: 0 } }}>
                            <Field
                              name={`otherBankLoanRelationship[${index}].iban`}
                              path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].iban`}
                              label="IBAN"
                              component={Input}
                              disabled={true}
                              InputProps={{
                                inputProps: { tabIndex: 0, maxLength: 23 }
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3} sx={{ mt: 0 }}>
                          <Grid
                            item
                            sm={isBankLoan ? 5 : 6}
                            xs={12}
                            component={!index ? TabletBox : RelativeBox}
                          >
                            <Field
                              name={`otherBankLoanRelationship[${index}].currency`}
                              path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].currency`}
                              label="Currency"
                              component={SelectAutocomplete}
                              disabled={true}
                              shrink
                              tabIndex="0"
                              datalistId="accountCurrencies"
                            />
                          </Grid>
                          <Grid
                            item
                            sm={isBankLoan ? 5 : 6}
                            xs={12}
                            component={!index ? TabletBox : RelativeBox}
                          >
                            <Field
                              name={`otherBankLoanRelationship[${index}].loanFacility`}
                              label="Finance/Facility type"
                              path={`${otherBankProspectPath}.otherBankLoanRelationship[${index}].loanFacility`}
                              component={SelectAutocomplete}
                              disabled={true}
                              tabIndex="0"
                              datalistId="loanOrFacilityType"
                            />
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </>
                )}
              </>
            )}
          </FieldArray>
        </>
      ) : (
        <GroupLabel>Borrowing loans from other banks are not declared</GroupLabel>
      )}
    </React.Fragment>
  );
};

CompanyBankingRelationshipsComponent.propTypes = {
  // Function props
  updateProspect: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setTouched: PropTypes.func.isRequired,

  // Boolean props
  isComeFromROScreens: PropTypes.bool,

  // Array props
  outsideUAE: PropTypes.arrayOf(
    PropTypes.shape({
      bankName: PropTypes.string,
      iban: PropTypes.string,
      currency: PropTypes.string,
      loanExists: PropTypes.bool,
      loanType: PropTypes.string,
      loanAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      loanCurrency: PropTypes.string,
      id: PropTypes.string
    })
  ),
  bankLoan: PropTypes.arrayOf(
    PropTypes.shape({
      basedIn: PropTypes.string,
      bankName: PropTypes.string,
      iban: PropTypes.string,
      currency: PropTypes.string,
      loanFacility: PropTypes.string,
      id: PropTypes.string
    })
  ),
  withinUAE: PropTypes.arrayOf(
    PropTypes.shape({
      bankName: PropTypes.string,
      iban: PropTypes.string,
      currency: PropTypes.string,
      loanExists: PropTypes.bool,
      loanType: PropTypes.string,
      id: PropTypes.string
    })
  ),

  // Object props
  values: PropTypes.shape({
    companyAccountWithBankOutsideUAE: PropTypes.bool,
    bankLoanWithCompanyAccount: PropTypes.bool,
    outsideUAE: PropTypes.array,
    otherBankLoanRelationship: PropTypes.array
  }).isRequired
};
